import { EventEmitter } from '@angular/core';
import type { ResultCommandInterface, UIResultCommandInterface } from '@nts/std/interfaces';
import { UUIDHelper } from '@nts/std/utility';
import { BehaviorSubject, Observable } from 'rxjs';

export class ModalCommandWrapper<TCommandResult> implements ResultCommandInterface<TCommandResult> {

    private internalHiddenOnMobile = false;
    private internalHiddenOnDesktop = false;

    closeModal = true;
    executed: EventEmitter<TCommandResult> = new EventEmitter<TCommandResult>();
    name: string;
    isCancel: boolean;
    internalCommand: UIResultCommandInterface<TCommandResult>;
    loading$ = new BehaviorSubject<boolean>(false);
    displayName$ = new BehaviorSubject<string>('');

    /**
     * Property per gestire la visualizzazione dell'etichetta del pulsante, di default è true
     */
    showDisplayName$ = new BehaviorSubject<boolean>(true);

    tooltip$ = new BehaviorSubject<string>('');
    iconClass$ = new BehaviorSubject<string>('');
    isVisible$ = new BehaviorSubject<boolean>(true);
    canExecute$ = new BehaviorSubject<boolean>(true);
    hiddenOnMobile$ = new BehaviorSubject<boolean>(this.internalHiddenOnMobile);
    hiddenOnDesktop$ = new BehaviorSubject<boolean>(this.internalHiddenOnDesktop);
    data: any;
    uid: string;
    onlyInMoreOptions: boolean;

    postExecute: (x: TCommandResult) => TCommandResult;

    isHighlighted(parameter: any): Observable<boolean> {
        return this.internalCommand.isHighlighted(parameter);
    }

    async execute(parameter: any): Promise<TCommandResult> {
        return this.internalCommand.execute(parameter);
    }

    constructor(
        command: UIResultCommandInterface<TCommandResult>,
        postExecute: (x: TCommandResult) => TCommandResult
    ) {
        this.internalCommand = command;
        this.isVisible$ = command.isVisible$;
        this.canExecute$ = command.canExecute$;
        this.loading$ = command.loading$;
        this.postExecute = postExecute;
        this.name = command.name;
        this.isCancel = command.isCancel;
        this.uid = UUIDHelper.generateUUID();
        this.internalCommand.executed.subscribe(async (s: TCommandResult) => {
            if (s instanceof Promise) {
                postExecute(await s);
            } else {
                postExecute(s);
            }
        });
    }

    destroy(destroyAll?: boolean): void {
        this.internalCommand = null;
        this.loading$?.complete();
        this.loading$ = null;
        this.displayName$?.complete();
        this.displayName$ = null;
        this.showDisplayName$?.complete();
        this.showDisplayName$ = null;
        this.tooltip$?.complete();
        this.tooltip$ = null;
        this.iconClass$?.complete();
        this.iconClass$ = null;
        this.isVisible$?.complete();
        this.isVisible$ = null;
        this.canExecute$?.complete();
        this.canExecute$ = null;
        this.hiddenOnMobile$?.complete();
        this.hiddenOnMobile$ = null;
        this.hiddenOnDesktop$?.complete();
        this.hiddenOnDesktop$ = null;
        this.executed?.complete();
        this.executed = null;
        this.data = null;
        this.postExecute = null;
    }

    get hiddenOnMobile(): boolean {
        return this.internalHiddenOnMobile;
    }

    set hiddenOnMobile(value: boolean) {
        this.internalHiddenOnMobile = value;
        this.hiddenOnMobile$.next(this.internalHiddenOnMobile);
    }

    get hiddenOnDektop(): boolean {
        return this.internalHiddenOnDesktop;
    }

    set hiddenOnDesktop(value: boolean) {
        this.internalHiddenOnDesktop = value;
        this.hiddenOnDesktop$.next(this.internalHiddenOnDesktop);
    }
}
